import React, { PropsWithChildren } from "react";
//#region types
import { LabelProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const Label: React.FC<PropsWithChildren<LabelProps>> = ({ children, inline, className }) => {
  return (
    <Grid item className={clsx(cssExports.formControlLabel, !inline ? cssExports.formLabelTop : "", className)}>
      {children}
    </Grid>
  );
};

export default Label;
